(function () {
  const GCR_KEY = "gcr_optin_config";

  const loadGapiScript = () => {
    return new Promise((resolve, reject) => {
      if (window.gapi) {
        resolve();
      } else {
        const script = document.createElement('script');
        script.src = "https://apis.google.com/js/platform.js";
        script.async = true;
        script.defer = true;
        script.onload = () => {
          console.log("[GCR] gapi script loaded");
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      }
    });
  };

  const triggerGCRPopup = () => {
    const stored = localStorage.getItem(GCR_KEY);
    if (!stored) return;

    try {
      const parsed = JSON.parse(stored);
      const optInConfig = parsed.config || parsed;

      // 可选：过期校验（24小时）
      const now = Date.now();
      if (parsed.timestamp && now - parsed.timestamp > 24 * 60 * 60 * 1000) {
        console.log("[GCR] optInConfig expired, removing...");
        localStorage.removeItem(GCR_KEY);
        return;
      }

      const tryRender = () => {
        if (window.gapi && window.gapi.surveyoptin) {
          console.log("[GCR] gapi.surveyoptin ready, rendering...");
          window.gapi.surveyoptin.render(optInConfig);
          localStorage.removeItem(GCR_KEY);
          console.log("[GCR] optInConfig rendered and removed");
        } else {
          console.log("[GCR] Waiting for gapi.surveyoptin...");
          setTimeout(tryRender, 300);
        }
      };

      window.gapi.load("surveyoptin", tryRender);
    } catch (e) {
      console.error("[GCR] Failed to parse optInConfig:", e);
    }
  };

  const setupPageChangeWatcher = () => {
    const runOnPageChange = () => {
      console.log("[GCR] Page load or navigation detected");
      triggerGCRPopup();
    };

    // 页面首次打开
    window.addEventListener("DOMContentLoaded", runOnPageChange);

    // 对于 SPA：监听 history.pushState 和 popstate
    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      runOnPageChange();
    };
    window.addEventListener("popstate", runOnPageChange);
  };

  // 主流程
  loadGapiScript()
    .then(() => {
      console.log("[GCR] gapi ready, setting up page watcher...");
      setupPageChangeWatcher();
      triggerGCRPopup(); // 页面首次加载也执行一次
    })
    .catch((err) => {
      console.error("[GCR] Failed to load gapi script:", err);
    });
})();
